import {
  GeneralInfoStatus,
  IGeneralInfo,
  IKatoTreeItem,
} from '../types/kato.types';
import {
  IInfrastructureProject,
  InfrastructureProjectType,
  IStreet,
} from '../types/project.types';
import { api } from './api';

const baseUrl = '/supervisor';

export const getSupervisorKatoTree = async (): Promise<IKatoTreeItem[]> => {
  return api.get(`${baseUrl}/kato/tree`).then((res) => res.data.list);
};

export const uploadPersonsImage = (
  kato: number,
  imageFile: File,
  year: number = 2024,
) => {
  const formData = new FormData();
  formData.append('imageFile', imageFile);
  formData.append('kato', kato.toString());
  formData.append('year', year.toString());

  return api
    .post(`${baseUrl}/general/akim/image/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => res.data);
};

export const uploadImage = (
  kato: number,
  imageFile: File,
  year: number = 2024,
) => {
  const formData = new FormData();
  formData.append('imageFile', imageFile);
  formData.append('kato', kato.toString());
  formData.append('year', year.toString());

  return api
    .post(`${baseUrl}/general/image/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => res.data);
};

export const deleteImage = (imageId: number) => {
  return api.delete(`${baseUrl}/image/remove/${imageId}`);
};

export const updateGeneralInfoData = (
  kato: number,
  data: Partial<IGeneralInfo>,
  year: number = 2024,
) => {
  return api.post(
    `${baseUrl}/general/partial/update?kato=${kato}&fillingStatus=${data.status}&year=${year}`,
    data,
  );
};

export const updateAutoLinkData = (
  kato: number,
  data: Partial<any>,
  year: number = 2024,
) => {
  return api.post(
    `${baseUrl}/general/partial/update?kato=${kato}&fillingStatus=${data.status}&year=${year}`,
    data,
  );
};

export const changeStatus = (kato: number, status: GeneralInfoStatus) => {
  return api.post(`${baseUrl}/status?kato=${kato}&status=${status}`);
};

export const deleteAll = (kato: number, year: number = 2024) => {
  return api.delete(`${baseUrl}/delete?kato=${kato}&year=${year}`);
};

export const createInfrastructureProject = (
  kato: number,
  type: InfrastructureProjectType,
) => {
  return api
    .get(`${baseUrl}/infrastructure/create?kato=${kato}&type=${type}`)
    .then((res) => res.data.data);
};

export const uploadInfrastructureProjectImage = (
  kato: number,
  objectId: number,
  type: InfrastructureProjectType,
  fileType: 'IMAGE_CURRENT' | 'IMAGE_AFTER',
  date: Date,
  imageFile: File,
) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('objectId', objectId.toString());
  formData.append('fileType', fileType);
  formData.append('type', type);
  formData.append('imageFile', imageFile);

  return api
    .post(
      `${baseUrl}/infrastructure/image/upload?date=${date.toDateString()}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
    .then((res) => res.data);
};

export const updateInfrastructureProject = (
  type: InfrastructureProjectType,
  body: IInfrastructureProject,
) => {
  return api
    .post(`${baseUrl}/infrastructure/update?type=${type}`, { ...body })
    .then((res) => res.data);
};

export const createStreet = (
  parentSnpId: number,
  type: 'VILLAGE_ROAD_STREET' | 'LIGHTING_STREET',
) => {
  return api
    .get(
      `${baseUrl}/infrastructure/street/create?parentSnpId=${parentSnpId}&type=${type}`,
    )
    .then((res) => res.data.data);
};

export const updateStreets = (
  type: 'VILLAGE_ROAD_STREET' | 'LIGHTING_STREET',
  body: IStreet[],
) => {
  return api
    .post(`${baseUrl}/infrastructure/street/update?type=${type}`, body)
    .then((res) => res.data);
};

export const deleteStreet = (
  streetId: number,
  type: 'VILLAGE_ROAD_STREET' | 'LIGHTING_STREET',
) => {
  return api
    .delete(`${baseUrl}/infrastructure/street/${streetId}?type=${type}`)
    .then((res) => res.data);
};

export const uploadStreetImage = (
  kato: number,
  streetId: number,
  imageFile: File,
  type: 'VILLAGE_ROAD' | 'LIGHTING',
  fileType: 'IMAGE_CURRENT' | 'IMAGE_AFTER',
  date: Date,
) => {
  const formData = new FormData();
  formData.append('kato', kato.toString());
  formData.append('objectId', streetId.toString());
  formData.append('imageFile', imageFile);
  formData.append('type', `${type}_STREET`);
  formData.append('fileType', fileType);
  formData.append('date', date.toDateString());

  return api
    .post(`${baseUrl}/infrastructure/street/image/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => res.data);
};

export const deleteInfrastructureProject = (
  type: InfrastructureProjectType,
  objectId: number,
) => {
  return api.delete(`${baseUrl}/infrastructure/${objectId}?type=${type}`);
};
